<template>
<div id="main">
    <Header />
    <div id="wrapper">
        <div id="main-contents" class="clearfix">
            <div id="m-left-col">
              <Navbar/>
            </div>
            <div id="m-right-col">
              <slot/>
              <Footer/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/js/components/Navbar.vue'
import Footer from '@/js/components/Footer.vue'
import Header from '@/js/components/Header.vue'
import { isLogin } from "@/js/commons/commons"

export default {
  components: {
    Navbar,
    Footer,
    Header
  },
  async mounted() {
    if (
        isLogin() &&
        (this.$store.state.auth.typeOfUser === 'doctor' || this.$store.state.auth.typeOfUser === 'doctor-nanamedi') && 
        (this.$route.path !== '/404' && this.$route.path !== '/login')
      ) {
      await this.$store.dispatch('auth/getDoctorInfo')
    }
  }
}
</script>
